/* combo-lightbox.js — shared image lightbox for KFO/Holst pairing photos.

   Exposes window.BfComboLightbox with:
     open(imgSrc, caption)  — opens or replaces the lightbox
     close()                — closes if open
     contains(node)         — true when node is inside the active lightbox
                              (lets host pages guard outside-click handlers)

   Used by:
     - assets/color-combinations.js     (combos overview page)
     - assets/pdp-pairings.js           (PDP "Farbkombinationen" tab)
*/
(function () {
  'use strict';
  if (window.BfComboLightbox) return;

  let el = null;

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  function open(imgSrc, caption) {
    close();
    el = document.createElement('div');
    el.className = 'combo-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');

    const img = document.createElement('img');
    img.className = 'combo-lightbox__img';
    img.src = imgSrc;
    img.alt = caption || '';
    el.appendChild(img);

    if (caption) {
      const cap = document.createElement('p');
      cap.className = 'combo-lightbox__caption';
      cap.textContent = caption;
      el.appendChild(cap);
    }

    const closeBtn = document.createElement('button');
    closeBtn.className = 'combo-lightbox__close';
    closeBtn.setAttribute('aria-label', 'Schließen');
    closeBtn.textContent = '×';
    closeBtn.addEventListener('click', e => {
      // Stop the bubble so host-page outside-click handlers don't see
      // this click and treat it as "click outside" (would collapse the
      // KFO combos row panel otherwise).
      e.stopPropagation();
      close();
    });
    el.appendChild(closeBtn);

    el.addEventListener('click', e => {
      if (e.target !== el) return;
      e.stopPropagation();
      close();
    });

    document.body.appendChild(el);
    document.addEventListener('keydown', onKey);
  }

  function close() {
    if (!el) return;
    el.remove();
    el = null;
    document.removeEventListener('keydown', onKey);
  }

  function contains(node) {
    return !!(el && node && el.contains(node));
  }

  window.BfComboLightbox = { open, close, contains };
})();
